import { Routes, Route, Outlet, Navigate } from "react-router-dom";
import Dashboard from "../pages/Dashboard";
import { useContext } from "react";
import { MainContext } from "../../../main/context/MainContextProvider";
// import LayoutEditRoutes from "../../layoutEdit/router/LayoutEditRoutes";

export default function DashboardRoutes() {
  const { userIsAdm } = useContext(MainContext);
  return (
    <>
      <Routes>
        <Route
          path="/*"
          element={<Navigate to={userIsAdm ? "/clients" : "/dashboard"} />}
        />
        <Route path="/" element={<Dashboard />} />
        {/* <Route path="/edit/*" element={<LayoutEditRoutes />} /> */}
      </Routes>
      <Outlet />
    </>
  );
}
